export default function Logo({ variant = "light", className = "" }) {
  // variant: "light" => for light backgrounds (dark text + violet X)
  //         "dark"  => for dark backgrounds (white text + cyan X)
  const isDark = variant === "dark";
  const textColor = isDark ? "#F7F9FC" : "#07111F";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg width="28" height="28" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="xa-x-grad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#6D4DFF" />
            <stop offset="100%" stopColor="#00D4FF" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="30" height="30" rx="7" stroke="url(#xa-x-grad)" strokeWidth="1.5" />
        <path d="M9 9 L23 23 M23 9 L9 23" stroke="url(#xa-x-grad)" strokeWidth="2.6" strokeLinecap="round" />
        <circle cx="16" cy="16" r="2.4" fill="url(#xa-x-grad)" />
      </svg>
      <span className="font-display text-xl font-bold tracking-tight" style={{ color: textColor }}>
        Xadentra
      </span>
    </span>
  );
}
